export const benefitsData = [
  {
    benefitText: "benefit1",
    positionTop: "109px",
    positionLeft: "-117px",
    maxWidth: "199px",
  },
  {
    benefitText: "benefit2",
    positionTop: "320px",
    positionLeft: "-10px",
    maxWidth: "199px",
  },
  {
    benefitText: "benefit3",
    positionTop: "78px",
    positionRight: "-145px",
    maxWidth: "307px",
  },
  {
    benefitText: "benefit4",
    positionTop: "280px",
    positionRight: "-138px",
    maxWidth: "240px",
  },
];

export const howToJoinData = [
  {
    title: "how_to_join_title_1",
    description: "how_to_join_desc_1",
  },
  {
    title: "how_to_join_title_2",
    description: "how_to_join_desc_2",
  },
  {
    title: "how_to_join_title_3",
    description: "how_to_join_desc_3",
  },
  {
    title: "how_to_join_title_4",
    description: "how_to_join_desc_4",
  },
];
